import { add, differenceInMinutes, format, fromUnixTime, getHours, getMinutes, getUnixTime, isBefore, isSameDay, set } from "date-fns";
import i18next from "i18next";
import { FORM, ROLES } from "./constans";

export const preventDefault = event => event.preventDefault();

export const stopPropagation = event => event.stopPropagation();

export const createPreview = image => image && URL.createObjectURL(image);

export const generatePassword = () => Math.random().toString(36).slice(-8);

export const getImageUrl = (url) => url ? process.env.REACT_APP_API_URL + url : '';

export const parseDataToOptions = (data, pattern = { label: 'name', value: 'id' }) => {
    if (!!!data) return [];
    return data.map(item => ({ label: item[pattern.label], value: item[pattern.value] }));
};

export const parseUserSuppliersToOptions = (mangers) => {
    if (!!!mangers) return [];
    return mangers.map(manger => ({
        label: `${manger?.user?.first_name} ${manger?.user?.last_name}`,
        value: manger.id
    }));
};

export const parseTimeToArray = time => time.length > 0 ? time.toString().split(":").map(t => parseInt(t, 10)) : [0, 0];

export const parseDataToIDs = data => data ? data.map(item => item.id) : [];

export const filterDataByString = (data, searchText, selector) => {
    if (!!!data) return [];
    const searchValue = searchText.toString().toLowerCase().trim();
    return data.filter(item => {
        const value = selector(item);
        if (!value) return true;    
        return value.toString().toLowerCase().includes(searchValue);
    });
};

export const filterDataByDateAndSearch = (data, searchText, startDate, endDate) => {
    if (!!!data) return [];
    const searchValue = searchText.toString().toLowerCase().trim();
    const startValue = getUnixTime(startDate)
    const endValue = getUnixTime(endDate)
    return data.filter(item => {
        const title = item.title
        const time_end = item.time_end
        const time_start = item.time_start
        if (!title) return true;
        return title.toString().toLowerCase().includes(searchValue) && startValue <= time_end && time_start <= endValue
    });
};

export const findByID = (data, id) => (data && id) && data.find(item => parseInt(item?.id, 10) === parseInt(id, 10));

export const scrollbarWidth = () => {
    const scrollDiv = document.createElement('div');
    scrollDiv.setAttribute('style', 'width: 100px; height: 100px; overflow: scroll; position:absolute; top:-9999px;');
    document.body.appendChild(scrollDiv);
    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarWidth;
};

export const getLabelTime = minutes => {
    if (!minutes) return '';
    const minutesParsed = parseInt(minutes, 10);
    const hours = parseInt(minutesParsed / 60, 10);
    const minutesRest = parseInt(minutesParsed % 60, 10);
    return `${isNaN(hours) ? '0' : hours}g:${isNaN(minutesRest) ? '0' : minutesRest}m`
};

export const reverseArray = (array) => {
    if (!!!array) return [];
    return [...array].reverse();
}

/** Helpers TAGS */
export const findNewTag = (tagsHints, tags, tagName, isReturnNewTag) => {
    const newTag = tagsHints.find(tagHint => tagHint.name === tagName);
    if (!!newTag) {
        const isNotExists = !!!tags.find(tag => tag.id === newTag.id);
        if (isNotExists) {
            return {
                tag: newTag,
                name: tagName,
                error: false
            }
        } else {
            return {
                tag: null,
                name: tagName,
                error: true,
                message: FORM.VALUE_IS_EXISTS
            }
        }
    } else {
        return {
            tag: null,
            name: tagName,
            error: isReturnNewTag ? false : true,
            message: FORM.VALUE_IS_OUT_OF_LIST
        }
    }
};
/* Helpers TAGS **/

/** Helpers PROFESSIONS */
export const parseProffesion = profession => {
    if (!!!profession) return profession;
    return {
        name: profession?.name,
        language: profession?.language || "pl_PL",
        hourly_rate_user: profession?.hourly_rate_user,
        hourly_rate_admin: profession?.hourly_rate_admin,
        skills: profession?.skills_ids,
        form_values: {
            name: profession?.name,
            language: profession?.language || "pl_PL",
            hourly_rate_user: profession?.hourly_rate_user,
            hourly_rate_admin: profession?.hourly_rate_admin,
            skills_ids: parseDataToIDs(profession?.skills_ids)
        }
    };
}
/* Helpers PROFESSIONS **/

/** Helpers PLACES */
export const parsePlaces = places => {
    if (!!!places) return [];
    return places.map(place => {
        const user_supplier = place?.user_suppliers?.find(user_suppliers => user_suppliers?.user?.role?.type === ROLES.ADMINISTRATOR);
        return {
            ...place,
            id: place?.id,
            user_supplier: user_supplier,
            form_values: {
                logo: getImageUrl(place?.logo?.url),
                name: place?.name,
                description: place?.description,
                url: place?.url,
                location: {
                    address: place?.address,
                    lat: place?.lat,
                    lng: place?.lng
                },
                supplier_id: user_supplier?.id ?? '',
            }
        }
    });
}
export const parseDepartment = (departmnet) => {
    if (!!!departmnet) return departmnet;
    const form_values = {
        name: departmnet.name,
        phone: departmnet?.phone,
        professions_ids: parseDataToIDs(departmnet?.professions_ids)
    }
    return {
        ...departmnet,
        id: departmnet?.id,
        form_values_edit: {
            ...form_values,
            manager: departmnet?.user_supplier?.id ?? ""
        },
        form_values_duplicate: {
            ...form_values,
            manager: ""
        }
    };
}
export const parseDepartments = (departments) => {
    if (!!!departments) return departments;
    return departments.map(department => ({
        id: department?.id,
        name: department?.name,
        manager: department?.user_supplier ? `${department?.user_supplier?.user?.first_name} ${department?.user_supplier?.user?.last_name}` : '',
        phone: department?.phone,
        professions_ids: department?.professions_ids,
        options: ''
    }))
}
/* Helpers PLACES **/

/** Helpers USERS */
export const parseUsers = users => {
    if (!!!users) return [];
    return users
        .filter(user => user.is_active)
        .map(user => ({
            ...user,
            id: user?.id,
            user: {
                avatarSrc: null,
                avatarAlt: `${user?.user?.first_name} ${user?.user?.last_name}`,
                email: user?.user?.email,
                name: user?.user?.first_name,
                surname: user?.user?.last_name,
                role: user?.user?.role
            },
            username: user?.user?.username ? user?.user?.username : `${user?.user?.first_name} ${user?.user?.last_name}`,
            role_name: user?.user?.role?.name,
            department_name: user?.department_id?.name,
            place_name: user?.place_id?.name,
            form_values: {
                email: user?.user?.email,
                first_name: user?.user?.first_name,
                last_name: user?.user?.last_name,
                role_id: user?.user?.role?.id
            }
        }));
};
export const getShortcutUsername = (name, surname) => {
    return `${name?.[0] ?? ''}${surname?.[0] ?? ''}`;
};
/* Helpers USERS **/

/** Helpers APPLICATIONS */
export const parseApplications = appliacations => {
    if (!!!appliacations) return [];
    return appliacations.map(application => {
        // const minutes = (application?.job?.time_start && application?.job?.time_end) ? differenceInMinutes(fromUnixTime(application?.job?.time_end), fromUnixTime(application?.job?.time_start)) : 0;
        const minutes = (application?.user_time_start && application?.user_time_end) ? differenceInMinutes(fromUnixTime(application?.user_time_end), fromUnixTime(application?.user_time_start)) : 0;

        const hours = minutes / 60;
        const jobHourlyRateUser = application?.job?.hourly_rate_user || 0;
        return {
            object: application?.job?.place_id,
            object_name: application?.job?.place_id?.name,
            date: application?.job?.time_start && format(fromUnixTime(application?.job?.time_start), 'dd.MM.yyyy, HH:mm'),
            profession: application?.job?.profession_id?.name,
            hours: hours,
            candidate_ranking: application?.candidate_ranking || 0,
            cost: hours * jobHourlyRateUser
        }
    });
};
/* Helpers APPLICATIONS **/

/** Helpers REPORTS */
export const parseReports = reports => {
    if (!!!reports) return [];
    return reports.map(report => ({
        id: report?.id,
        date_place: {
            date: getUnixTime(new Date(report?.created_at)),
            place: report?.place?.logo?.url
        },
        name: report?.name,
        date_work: report.time_start_from ? parseInt(report.time_start_from) : '',
        work_days: report?.work_hours_amount || 0,
        rating: report?.average_ranking || 0,
        cost: parseNumberToFixed(report?.places_cost) || 0,
        absences_amount: report?.absences_amount || 0,
        late_amount: report?.absences_amount || 0,
        average_ranking: report?.average_ranking || 0,
        places_cost: parseNumberToFixed(report?.places_cost) || 0,
        time_from_creation_to_completion: report?.time_from_creation_to_completion || 'brak',
        work_hours_amount: report?.work_hours_amount || 0,
        time_start_from: report?.time_start_from,
        time_start_to: report?.time_start_to,
        job_reports: report?.job_reports && report?.job_reports.map(job_report => ({
            date: job_report?.job_time_start ? parseInt(job_report?.job_time_start) : '',
            name: job_report?.job_title,
            position: job_report?.profession_name,
            places_amount: job_report?.vacancies,
            applications_amount: job_report?.application_amount,
            absences: job_report?.absences_amount,
            hours: job_report?.work_hours,
            work_hours: parseNumberToFixed(job_report?.work_hours_amount),
            raings: job_report?.average_ranking,
            cost: job_report?.place_cost ? parseNumberToFixed(job_report?.place_cost) : 0,
        }))
    }));
};
export const calcSum = (data, selector) => {
    if (!!!data) return 0;
    return data.reduce((sum, item) => {
        const value = selector(item);
        if (!value) return sum;
        return value + sum
    }, 0);
};
export const calcAverage = (data, selector) => {
    if (!!!data) return 0;
    const sum = calcSum(data, selector);
    return parseNumberToFixed(sum / data.length);
};
export const parseNumberToFixed = value => {
    if (!!!value) return value;
    return Number.isInteger(value) ? value : parseFloat(value.toFixed(2));
};
/* Helpers REPORTS **/

/** Helpers JOBS */
export const parseJobs = jobs => {
    if (!!!jobs) return [];
    return jobs.map(job => {
        const timeStart = fromUnixTime(job?.time_start);
        const timeEnd = fromUnixTime(job?.time_end);
        const vacancies_diff = job?.vacancies - job?.vacancies_available;
        return ({
            ...job,
            time_range: `${format(timeStart, 'HH:mm')} - ${format(timeEnd, 'HH:mm')}`,
            time_hours: getLabelHoursJob(timeEnd, timeStart),
            status: job?.vacancies > 0 ? (vacancies_diff / job?.vacancies) * 100 : 0,
            profession: job?.profession_id?.name,
            vacancies_diff: vacancies_diff,
            supplier: `${job?.supplier_id?.user?.first_name ?? ""} ${job?.supplier_id?.user?.last_name ?? ""}`,
            form_values: {
                title: job?.title,
                profession_id: job?.profession_id?.id,
                start_ranking: job?.start_ranking,
                vacancies: job?.vacancies,
                time_start: job?.time_start,
                time_end: job?.time_end,
                time_offset: job?.time_offset,
                requirements_ids: parseDataToIDs(job?.requirements_ids),
                languages: parseDataToIDs(job?.languages),
                comment: job?.comment,
                supplier_id: job?.supplier_id?.id,
                place_id: job?.place_id?.id
            }
        })
    });
}
export const parseJobsToExpanded = (jobs, id) => {
    if (jobs && id) {
        return jobs.reduce((acc, job) => {
            if (parseInt(job?.id, 10) === parseInt(id, 10)) {
                return [{ ...job, expanded: true }, ...acc];
            } else {
                return [...acc, job];
            }
        }, []);
    } else {
        return jobs;
    }
}
export const parseCandidates = candidates => {
    if (!!!candidates) return [];
    return candidates.map(candidate => ({
        id: candidate?.id,
        user_id: candidate?.user,
        avatarSrc: getImageUrl(candidate?.avatar?.url),
        avatarAlt: `${candidate?.first_name} ${candidate?.last_name}`,
        rating: candidate?.rankings,
        name: candidate?.first_name,
        surname: candidate?.last_name,
        username: candidate?.username ?? `${candidate?.first_name} ${candidate?.last_name}`,
        application_id: candidate?.application_id
    }));
}
export const parseJobsApplications = (applications, candidates) => {
    if (!!!applications || !!!candidates) return [];
    return applications
        .filter(application => !!candidates.find(candidate => parseInt(candidate?.application_id, 10) === parseInt(application?.id, 10)))
        .map(application => {
            const username = application?.user_candidate?.user?.username ? application?.user_candidate?.user?.username : `${application?.user_candidate?.user?.first_name} ${application?.user_candidate?.user?.last_name}`;
            return {
                id: application?.id,
                username,
                user_candidate_id: application?.user_candidate?.id,
                user_candidate: {
                    avatarSrc: getImageUrl(application?.user_candidate?.avatar?.url),
                    avatarAlt: username,
                    name: application?.user_candidate?.user?.first_name,
                    surname: application?.user_candidate?.user?.last_name,
                    username,
                },
                user_candidate_rankings: application?.user_candidate?.rankings,
                is_penalty: application?.is_penalty,
                user_time_start: application?.user_time_start,
                user_time_end: application?.user_time_end,
                student: application?.user_candidate?.is_active_student ? i18next.t('tak') : i18next.t('nie'),
                candidate_ranking: application?.candidate_ranking
            };
        });
}
export const parseInitialValuesJob = values => {
    if (values?.time_start) {
        const today = new Date();
        const tomorrow = add(today, { days: 1 });
        const timeStart = fromUnixTime(values?.time_start);
        const timeEnd = fromUnixTime(values?.time_end);

        if (isBefore(timeStart, today)) {
            return {
                ...values,
                time_start: getUnixTime(set(tomorrow, { hours: getHours(timeStart), minutes: getMinutes(timeStart) })),
                time_end: getUnixTime(set(tomorrow, { hours: getHours(timeEnd), minutes: getMinutes(timeEnd) }))
            }
        }
        return values;
    }

    return values;
}
export const getLabelHoursJob = (end, start) => {
    if (!start && !end) return '0 godzin';
    const diffMinutes = differenceInMinutes(end, start);
    const diffHours = diffMinutes / 60;
    if (diffMinutes < 0) {
        return i18next.t("{{hour}} godzin", { hour: 0 });
    } else {
        if (Number.isInteger(diffHours)) {
            return i18next.t("{{hour}} godzin", { hour: diffHours });
        } else {
            if (parseInt(diffHours, 10) > 0) {
                return i18next.t("{{hour}} godzin {{minutes}} minut", { hour: parseInt(diffHours, 10), minutes: diffMinutes % 60 });
            } else {
                return i18next.t("{{minutes}} minut", { minutes: diffMinutes % 60 });
            }
        }
    }
}
export const getLabelDateStartJob = (date) => {
    const today = new Date();
    const diffMinutes = differenceInMinutes(date, today);
    const diffHours = diffMinutes / 60;
    const diffDays = diffHours / 24;
    if (isSameDay(date, today)) {
        return i18next.t("Dzisiaj");
    } else {
        if (diffDays >= 0) { // Future
            if (isSameDay(date, add(today, { days: 1 }))) {
                return i18next.t(`Jutro`)
            } else {
                return i18next.t(`Zostało {{days}} dni`, { days: Math.abs(parseInt(diffDays, 10)) })
            }
        } else { // Past
            if (isSameDay(date, add(today, { days: -1 }))) {
                return i18next.t("Wczoraj")
            } else {
                return i18next.t(`Zakończyło się {{days}} dni temu`, { days: Math.abs(parseInt(diffDays, 10)) })
            }
        }
    }
}
/* Helpers JOBS **/

/** Helpers RATINGS */
export const parseRatings = (ratings) => {
    if (!!!ratings) return ratings;
    return ratings.map(rating => {
        const candidate_name = `${rating?.candidate?.first_name} ${rating?.candidate?.last_name}`;
        return {
            department: rating?.department?.name,
            application: rating?.job?.title,
            date: rating.time_start && format(fromUnixTime(rating.time_start), 'dd.MM.yyyy, HH:mm'),
            candidate_name,
            candidate: {
                avatarSrc: getImageUrl(rating?.candidate?.avatar?.url),
                avatarAlt: candidate_name,
                name: rating?.candidate?.first_name,
                surname: rating?.candidate?.last_name,
                username: candidate_name
            },
            profession: rating?.profession?.name,
            rating: rating?.rating
        }
    });
}
/* Helpers RATINGS **/

/** Helpers CHAT */
export const parseChatCandidates = (candidates) => {
    if (!!!candidates) return [];
    return [...candidates]
        // .sort((x, y) => {
        //     return (x?.is_unread === y?.is_unread) ? 0 : x?.is_unread ? -1 : 1;
        // })
        .map(candidate => {
            return Object.keys(candidate).reduce((acc, key) => {
                if (key === "first_name" || key === "last_name") {
                    return {
                        ...acc,
                        username: acc?.username ? acc?.username : `${acc?.first_name} ${acc?.last_name}`,
                    }
                } else if (key === "job") {
                    return {
                        ...acc,
                        job: {
                            ...acc?.job,
                            profession_id: {
                                name: acc?.job?.profession_name
                            }
                        }
                    }
                } else if (key === "last_job") {
                    return {
                        ...acc,
                        last_job: {
                            ...acc?.last_job,
                            profession_id: {
                                name: acc?.last_job?.profession_name
                            }
                        }
                    }
                } else {
                    return acc;
                }
            }, { ...candidate });
        })
}
/* Helpers CHAT **/

/** Helpers WORKERS */
export const parseWorkers = (workers) => {
    if (!!!workers) return workers;
    return workers
        .filter(worker => worker.is_active)
        .map(worker => ({
            id: worker?.id,
            worker: {
                avatar: getImageUrl(worker?.avatar?.url),
                name: `${worker?.user?.first_name || i18next.t('brak')} ${worker?.user?.last_name || i18next.t('brak')}`
            },
            username: worker?.user?.username ? worker?.user?.username : `${worker?.user?.first_name} ${worker?.user?.last_name}`,
            address: worker?.address_live_id ? `${worker?.address_live_id?.city || i18next.t('brak')}, ${worker?.address_live_id?.street || i18next.t('brak')} ${worker?.address_live_id?.number || i18next.t('brak')}, ${worker?.address_live_id?.post_code || i18next.t('brak')}` : i18next.t('brak'),
            rating: worker?.rankings || 0,
            email: worker?.user?.email || i18next.t('brak'),
            phone: worker?.phone || i18next.t('brak'),
            student: worker?.is_active_student ? i18next.t('tak') : i18next.t('nie')
        }))
}
export const parseWorker = (worker) => {
    
    if (!!!worker) return worker;
    return {
        user: worker?.user,
        id: worker.id,
        avatarUrl: getImageUrl(worker.avatar?.url),
        firstName: worker?.user?.first_name,
        lastName: worker?.user?.last_name,
        rating: worker.rankings,
        pesel: worker.national_id,
        birthDate: worker.dob,
        birthPlace: worker.birth_place,
        citizenship: worker.nationality,
        bankNumber: worker.bank_account,
        studentIdExpiryDate: worker.student_id_expiry_date,
        isActiveStudent: worker.is_active_student,
        passport: worker.passport,
        personalIDObverse: worker.personal_id_obverse,
        personalIDReverse: worker.personal_id_reverse,
        dataVerified: worker.data_verified,
        updated: worker.updated_at,
        conformityDeclarationAccepted: worker.conformity_declaration_accepted,
        bankCountry: worker.bank_account_country,
        professions: worker.professions,
        validityDate: worker.health_book_expires,
        ordersNumberTotal: worker?.applications?.length,
        email: worker?.user?.email,
        phonePrefix: worker.phone_prefix,
        phoneNumber: worker.phone,
        address: {
            street: worker.address_live_id?.street,
            houseNumber: worker.address_live_id?.number,
            apartmentNumber: worker.address_live_id?.flat,
            postcode: worker.address_live_id?.post_code,
            town: worker.address_live_id?.city,
        },
        registeredAddress: worker?.address_registered_id === null ? {
            street: worker.address_live_id?.street,
            houseNumber: worker.address_live_id?.number,
            apartmentNumber: worker.address_live_id?.flat,
            postcode: worker.address_live_id?.post_code,
            town: worker.address_live_id?.city,
        } : {
            street: worker.address_registered_id?.street,
            houseNumber: worker.address_registered_id?.number,
            apartmentNumber: worker.address_registered_id?.flat,
            postcode: worker.address_registered_id?.post_code,
            town: worker.address_registered_id?.city,
        },
        correspondenceAddress: worker?.address_post_id === null ? {
            street: worker.address_live_id?.street,
            houseNumber: worker.address_live_id?.number,
            apartmentNumber: worker.address_live_id?.flat,
            postcode: worker.address_live_id?.post_code,
            town: worker.address_live_id?.city,
        } : {
            street: worker.address_post_id?.street,
            houseNumber: worker.address_post_id?.number,
            apartmentNumber: worker.address_post_id?.flat,
            postcode: worker.address_post_id?.post_code,
            town: worker.address_post_id?.city,
        },
        languages: worker.languages
    }
}
export const parseWorkerAdditional = (worker) => {
    if (!!!worker) return worker;
    return {
        placesCost: worker?.placesCost?.toFixed(2) || 0,
        ordersTimeTotal: worker?.ordersTimeTotal || 0,
        absencesAmount: worker?.absencesAmount || 0,
        lateAmount: worker?.lateAmount || 0,
    }
}
/* Helpers WORKERS **/

/** Helpers NOTIFICATIONS */
export const parseNotifications = notifications => {
    if (!!!notifications) return [];
    return notifications.map(notification => notification?.data ? ({ ...notification, data: JSON.parse(notification.data) }) : notification);
}
export const getLabelDateCreatedNotification = (date) => {
    const created = new Date(date);
    const today = new Date();
    const diffMinutes = differenceInMinutes(today, created);
    const minutes = diffMinutes % 60;
    const hours = parseInt(diffMinutes / 60, 10) % 24;
    const days = parseInt((diffMinutes / 60) / 24, 10);
    if (days > 0) {
        return i18next.t(`{{days}} dni temu`, { days });
    } else if (hours > 0) {
        return i18next.t(`{{hours}} godziny {{minutes}} minut temu`, { hours, minutes });
    } else if (minutes > 0) {
        return i18next.t(`{{minutes}} minut temu`, { minutes });
    } else {
        return i18next.t(`teraz`);
    }
}
/* Helpers NOTIFICATIONS **/